import actionTypes from './actionTypes';
import type { RateCardSideId } from '../constants';
import type { ILoadLinesRequestPayload, ILoadLinesSuccessPayload, IRateCardLineHeader, IRateCardShow } from '../types';

const actions = {
  loadCardRequest: (payload: { id: string; silent?: boolean }) => ({ type: actionTypes.LOAD_CARD_REQUEST, payload }),
  loadCardSuccess: (payload: IRateCardShow) => ({ type: actionTypes.LOAD_CARD_SUCCESS, payload }),
  loadCardError: () => ({ type: actionTypes.LOAD_CARD_ERROR }),
  loadCardNotFound: () => ({ type: actionTypes.LOAD_CARD_NOT_FOUND }),

  pollStart: (payload: { id: string }) => ({ type: actionTypes.POLL_START, payload }),
  pollStop: () => ({ type: actionTypes.POLL_STOP }),
  pollAbandoned: () => ({ type: actionTypes.POLL_ABANDONED }),

  loadLineCountRequest: (payload: { id: string }) => ({ type: actionTypes.LOAD_LINE_COUNT_REQUEST, payload }),
  loadLineCountSuccess: (payload: { total: number }) => ({ type: actionTypes.LOAD_LINE_COUNT_SUCCESS, payload }),
  loadLineCountError: () => ({ type: actionTypes.LOAD_LINE_COUNT_ERROR }),

  loadLineHeadersRequest: (payload: { id: string; side: RateCardSideId }) => ({
    type: actionTypes.LOAD_LINE_HEADERS_REQUEST,
    payload,
  }),
  loadLineHeadersSuccess: (payload: { headers: IRateCardLineHeader[] }) => ({
    type: actionTypes.LOAD_LINE_HEADERS_SUCCESS,
    payload,
  }),
  loadLineHeadersError: () => ({ type: actionTypes.LOAD_LINE_HEADERS_ERROR }),

  loadLinesRequest: (payload: ILoadLinesRequestPayload) => ({ type: actionTypes.LOAD_LINES_REQUEST, payload }),
  loadLinesSuccess: (payload: ILoadLinesSuccessPayload) => ({ type: actionTypes.LOAD_LINES_SUCCESS, payload }),
  loadLinesError: () => ({ type: actionTypes.LOAD_LINES_ERROR }),

  exportLinesRequest: (payload: { id: string; side: RateCardSideId; cardName: string }) => ({
    type: actionTypes.EXPORT_LINES_REQUEST,
    payload,
  }),
  exportLinesSettled: (payload: { side: RateCardSideId }) => ({
    type: actionTypes.EXPORT_LINES_SETTLED,
    payload,
  }),

  deleteRequest: (payload: { id: string }) => ({ type: actionTypes.DELETE_REQUEST, payload }),
  deleteSuccess: () => ({ type: actionTypes.DELETE_SUCCESS }),
  deleteError: () => ({ type: actionTypes.DELETE_ERROR }),

  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
